export default "__VITE_ASSET__CuIFlIPZ__"